import { IChildrenProps } from '@/typings/children-props'

export const RestaurantDealPreview = ({ children }: IChildrenProps) => {
    return (
        <div
            className="bg-neotaste rounded-full w-fit flex items-center justify-center px-3 font-semibold text-[12px] py-2
                gap-x-1 whitespace-nowrap min-h-8 max-h-8"
        >
            <span className="mt-[1px]">{children}</span>
        </div>
    )
}
